import {dawaAutocomplete} from 'dawa-autocomplete2'
import { onMounted, ref, watchEffect} from 'vue';

export default {
    name: "FormAddressField",
    props: { 
        addressLineValue: {
            type: String,
            required:true
        },
        zipCodeValue: {
            type: String,
            required:true
        },
        cityValue: {
            type: String,
            required:true
        },
        addressPlaceholder: {
            type: String,
            required:false
        },
        zipCodePlaceholder: {
            type: String,
            required:false
        },
        cityPlaceholder: {
            type: String,
            required:false
        },
        addressLabel: {
            type: String,
            required:false,
            default: "Adresse og husnummer"
        },
        zipCodeLabel: {
            type: String,
            required:false,
            default: "Postnummer"
        },
        cityLabel: {
            type: String,
            required:false,
            default: "By"
        },
        errorMessageLabel: {
            type: String,
            required:true
        },
        isValidationError: {
            type: Boolean,
            required:true
        },
        onchangeCallback: {
            type: Function,
            required:false
        },
        onclickCallback: {
            type: Function,
            required:false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        isRequired: {
            type: Boolean,
            required: false,
            default: true
        },
    },
    setup(props, {emit}){
        const addressLine = ref(props.addressLineValue ?? '')
        const zipCode = ref(props.zipCodeValue ?? '')
        const city = ref(props.cityValue ?? '')

        watchEffect(() => {
            emit('update:addressLineValue', addressLine.value)
            emit('update:zipCodeValue', zipCode.value)
            emit('update:cityValue', city.value)
        })

        const clearAddress = function () {
            addressLine.value = ''
            zipCode.value = ''
            city.value = ''
        }

        onMounted(()=>{
            const mainInput = document.querySelector('.dawa-adresse-vej')
            const zipcodeInput = document.querySelector('.dawa-adresse-postnr')
            const cityInput = document.querySelector('.dawa-adresse-postnrnavn')

            // intentionally forcing input to be made in mainInput
            zipcodeInput.addEventListener('focus',()=>{
                mainInput.focus()
            })
            cityInput.addEventListener('focus',()=>{
                mainInput.focus()
            })

            dawaAutocomplete(mainInput, {
                select: function(selected) {
                    zipCode.value = selected.data.postnr
                    city.value = selected.data.postnrnavn

                    setTimeout(()=> {
                        const floor = selected.data.etage ? selected.data.etage : ''
                        const door = selected.data.dør ? selected.data.dør: ''
                        addressLine.value = `${selected.data.adresseringsvejnavn} ${selected.data.husnr} ${floor} ${door}`.trim()

                        emit('update:addressSelected', {
                            addressLine: addressLine.value,
                            zipCode: zipCode.value,
                            city: city.value
                        })

                    }, 100)
                }
            })
        })
    
        return {
            addressLine,
            zipCode,
            city,
            clearAddress
        }
    }
}